import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/event/actions";

//Components

import EventList from "../../components/EventList";
import EventDetail from "../../components/EventDetails";
import EventCreate from "../../components/EventCreate";

class Events extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleFetchAllEvent = () => {
    this.props.actions.fetchAllEvent();
  };

  handleFetchSingleEvent = (data) => {
    this.props.actions.fetchSingleEvent(data);
  };

  handleFetchCountry = (data) => {
    this.props.actions.fetchEventCountry(data);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchEventState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchEventCity(data);
  };

  handleCreateEvent = (data) => {
    this.props.actions.createEvent(data);
  };

  handleUpdateEvent = (data) => {
    this.props.actions.updateEvent(data);
  };

  handleFetchEventsForModeration = (data) => {
    this.props.actions.fetchEventForModeration(data);
  };

  handleEventModeration = (data, status) => {
    this.props.actions.moderateEvent(data, status);
  };

  handleEventGallery = (data) => {
    this.props.actions.moderateEventGallery(data);
  };

  handleUsersForJoinEvent = (data) => {
    this.props.actions.fetchUserForJoinRide(data);
  };

  handleUsersModerationForJoinEvent = (data) => {
    this.props.actions.moderateUserForRide(data);
  };

  handleFetchAllUser = (data) => {
    this.props.actions.fetchAllUser(data);
  };

  handleJoinUser = (data) => {
    this.props.actions.joinNewUser(data);
  };

  handleClearPreviousReducer = () => {
    this.props.actions.clearPreviousReducer();
  };

  handleUpdateEventAdmin = (data) => {
    this.props.actions.updateEventByAdmin(data);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "list":
        return (
          <EventList
            page={page}
            allEvents={this.props.allEvents}
            allEventsStatus={this.props.allEventsStatus}
            handleFetchAllEvent={this.handleFetchAllEvent}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            elements={this.props.elements}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            query={this.props.location.search}
            allUser={this.props.allUser}
            allUserStatus={this.props.allUserStatus}
            handleEventGallery={this.handleEventGallery}
            handleUsersForJoinEvent={this.handleUsersForJoinEvent}
            handleUsersModerationForJoinEvent={
              this.handleUsersModerationForJoinEvent
            }
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchAllUser={this.handleFetchAllUser}
            handleJoinUser={this.handleJoinUser}
            usersToJoinEventStatus={this.props.usersToJoinEventStatus}
            usersToJoinEvent={this.props.usersToJoinEvent}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateEventGalleryStatus={this.props.moderateEventGalleryStatus}
            handleEventModeration={this.handleEventModeration}
          />
        );

      case "create":
        return (
          <EventCreate
            page={page}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            createEventStatus={this.props.createEventStatus}
            query={this.props.location.search}
            userProfile={this.props.userProfile}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleCreateEvent={this.handleCreateEvent}
            handleUpdateEvent={this.handleUpdateEvent}
            elements={this.props.elements}
          />
        );

      case "update":
        return (
          <EventCreate
            page={page}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            userProfile={this.props.userProfile}
            updateEventStatus={this.props.updateEventStatus}
            query={this.props.location.search}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleCreateEvent={this.handleCreateEvent}
            handleUpdateEvent={this.handleUpdateEvent}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            elements={this.props.elements}
          />
        );

      case "event-update":
        return (
          <EventCreate
            page={page}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            userProfile={this.props.userProfile}
            updateEventStatus={this.props.updateEventStatus}
            query={this.props.location.search}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            handleUpdateEventAdmin={this.handleUpdateEventAdmin}
            handleCreateEvent={this.handleCreateEvent}
            handleUpdateEvent={this.handleUpdateEvent}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            elements={this.props.elements}
          />
        );

      case "detail":
        return (
          <EventDetail
            page={page}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            query={this.props.location.search}
            allUser={this.props.allUser}
            allUserStatus={this.props.allUserStatus}
            handleEventGallery={this.handleEventGallery}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            handleUsersForJoinEvent={this.handleUsersForJoinEvent}
            handleUsersModerationForJoinEvent={
              this.handleUsersModerationForJoinEvent
            }
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchAllUser={this.handleFetchAllUser}
            handleJoinUser={this.handleJoinUser}
            usersToJoinEventStatus={this.props.usersToJoinEventStatus}
            usersToJoinEvent={this.props.usersToJoinEvent}
            moderationStatusForUser={this.props.moderationStatusForUser}
            elements={this.props.elements}
            moderateEventGalleryStatus={this.props.moderateEventGalleryStatus}
            handleEventModeration={this.handleEventModeration}
          />
        );

      case "moderation":
        return (
          <EventList
            page={page}
            eventForModerationStatus={this.props.eventForModerationStatus}
            eventForModeration={this.props.eventForModeration}
            handleFetchEventsForModeration={this.handleFetchEventsForModeration}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            elements={this.props.elements}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            query={this.props.location.search}
            allUser={this.props.allUser}
            allUserStatus={this.props.allUserStatus}
            handleEventGallery={this.handleEventGallery}
            handleUsersForJoinEvent={this.handleUsersForJoinEvent}
            handleUsersModerationForJoinEvent={
              this.handleUsersModerationForJoinEvent
            }
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            handleFetchAllUser={this.handleFetchAllUser}
            handleJoinUser={this.handleJoinUser}
            usersToJoinEventStatus={this.props.usersToJoinEventStatus}
            usersToJoinEvent={this.props.usersToJoinEvent}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateEventGalleryStatus={this.props.moderateEventGalleryStatus}
            handleEventModeration={this.handleEventModeration}
          />
        );

      case "moderation-detail":
        return (
          <EventDetail
            page={page}
            singleEvent={this.props.singleEvent}
            singleEventStatus={this.props.singleEventStatus}
            query={this.props.location.search}
            handleFetchSingleEvent={this.handleFetchSingleEvent}
            handleEventModeration={this.handleEventModeration}
            handleEventGallery={this.handleEventGallery}
            elements={this.props.elements}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            allUser={this.props.allUser}
            allUserStatus={this.props.allUserStatus}
            handleUsersForJoinEvent={this.handleUsersForJoinEvent}
            handleUsersModerationForJoinEvent={
              this.handleUsersModerationForJoinEvent
            }
            handleFetchAllUser={this.handleFetchAllUser}
            handleJoinUser={this.handleJoinUser}
            usersToJoinEventStatus={this.props.usersToJoinEventStatus}
            usersToJoinEvent={this.props.usersToJoinEvent}
            moderationStatusForUser={this.props.moderationStatusForUser}
            moderateEventGalleryStatus={this.props.moderateEventGalleryStatus}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    allUserStatus: state.Events.allUserStatus,
    allUser: state.Events.allUser,
    countryStatus: state.Events.countryStatus,
    countries: state.Global.countries,
    stateStatus: state.Events.stateStatus,
    states: state.Events.states,
    cityStatus: state.Events.cityStatus,
    cities: state.Events.cities,
    allEvents: state.Events.allEvents,
    allEventsStatus: state.Events.allEventsStatus,
    singleEvent: state.Events.singleEvent,
    singleEventStatus: state.Events.singleEventStatus,
    createEventStatus: state.Events.createEventStatus,
    updateEventStatus: state.Events.updateEventStatus,
    userProfile: state.Auth.userProfile,
    elements: state.Elements.elements,
    eventForModerationStatus: state.Events.eventForModerationStatus,
    usersToJoinEventStatus: state.Events.usersToJoinEventStatus,
    usersToJoinEvent: state.Events.usersToJoinEvent,
    moderationStatusForUser: state.Events.moderationStatusForUser,
    eventForModeration: state.Events.eventForModeration,
    moderateEventGalleryStatus: state.Events.moderateEventGalleryStatus,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Events));
